import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { isWorkflowInput } from "@/components/Workflow/constants";
import { iconClasses } from "@/composables/useInvocationGraph";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NodeInvocationText',
    props: {
        invocationStep: null
    },
    setup(__props) {
        const props = __props;
        const statePlaceholders = {
            ok: "successful",
            error: "failed",
        };
        return { __sfc: true, props, statePlaceholders, FontAwesomeIcon, isWorkflowInput, iconClasses };
    }
});
